import { render, staticRenderFns } from "./UcRegisterEntryHeader.yaml?vue&type=template&id=0ef5575a&component"
import script from "./UcRegisterEntryHeader.yaml?vue&type=script&lang=ts&component"
export * from "./UcRegisterEntryHeader.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports